/* ViewStatsBadge — شارة مُشاهَدات مُبَسَّطة (أيقونة عَين + رقم).
   تَظهَر بِجانب اسم المحامي في MyLawyerCard. */
import { useEffect, useState } from "react";
import { Eye } from "@phosphor-icons/react";
import { getMyViewStats } from "../../lib/api";

export default function ViewStatsBadge() {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    getMyViewStats()
      .then((d) => { if (alive) setStats(d); })
      .catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, []);

  if (err || !stats) return null;
  const week = stats.this_week || 0;
  const total = stats.total || 0;

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#0A192F]/5 border border-[#0A192F]/10 text-[#5A6470] text-[10.5px] font-bold tabular-nums"
      title={`${total} مُشاهَدة إجماليّة · ${week} هذا الأُسبوع`}
      data-testid="view-stats-badge"
    >
      <Eye size={11} weight="fill" className="text-[#5A6470]" />
      <span data-testid="view-stats-week">{week}</span>
    </span>
  );
}
